function Strapi() {
    let CMS_BASE_URL = process.env.REACT_APP_CMS_BASE_URL;

    return CMS_BASE_URL;
}

export default Strapi;